module.exports = __webpack_public_path__ + "static/media/17909150_1410423102333859_885640162_n.ebf5a70e.jpg";